
import Cell from 'vux/src/components/cell/index.vue'

import { InsurStore } from '../store'

export default {
data() {
return {

banner:''
}
},
components: {
Cell,
},
computed: {
insurance() {
return InsurStore.insurance
}
},
created(){
this.banner = this.insurance.cache.details_img
}
}

